const Checkbox = ({ onChangeCallback, checked, otherAttributes, name }) => {
  return (
    <input
      type="checkbox"
      className="form-checkbox rounded flex-no-shrink p-2 mr-2 border-2 border-green"
      onChange={onChangeCallback}
      checked={checked}
      aria-label={`Show ${name} boundaries`}
      {...otherAttributes}
    />
  );
};

export default Checkbox;
